export default __webpack_public_path__ + "static/media/tea.9f2b3ea3.png";